import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { fetchTenantById } from '@/api/tenants/tenantsApi';
import type { TenantDetail } from '@/api/tenants/tenantsApi.types';
import { buildTenantQueryKey } from '@/constants/queryKeys';

export function useTenantQuery(tenantId: string): UseQueryResult<TenantDetail, Error> {
  return useQuery({
    queryKey: buildTenantQueryKey(tenantId),
    queryFn: function loadTenant() {
      return fetchTenantById(tenantId);
    },
  });
}
